import { createApp } from 'vue';
import VueCookies from 'vue-cookies';
import App from "./App.vue";
import './registerServiceWorker';
import axios from "axios";
import router from './router';
import store from './store'
import VueAxios from "vue-axios";
import i18n from './i18n'


createApp(App).use(VueAxios, axios).use(VueCookies).use(i18n).use(store).use(router).mount('#app');
